import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fi from './fi.json';
import en from './en.json';

const SUPPORTED_LANGUAGES = ['fi', 'en'];

function detectInitialLanguage() {
  const stored = localStorage.getItem('safepro_language');
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;

  const browserLang = (navigator.language || 'fi').toLowerCase();
  const exact = SUPPORTED_LANGUAGES.find(l => l === browserLang);
  if (exact) return exact;
  const prefix = SUPPORTED_LANGUAGES.find(l => browserLang.startsWith(l + '-') || browserLang.startsWith(l));
  return prefix || 'fi';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fi: { translation: fi },
      en: { translation: en },
    },
    lng: detectInitialLanguage(),
    fallbackLng: 'fi',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
